import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {PresenzeGiustificativo} from "@commons/mapping/PresenzeGiustificativo";

import {GiustificativoRecord} from "@commons/mapping/GiustificativoRecord";
import {ObjectFactory} from "@commons/types";
import {merge} from "lodash";
import {FieldValues} from "react-hook-form/dist/types";

export interface PresenzeGiustificativoEx extends PresenzeGiustificativo {
    giustificativo: GiustificativoRecord | null,
}

export class PresenzeGiustificativoEx {
    static factory: ObjectFactory<PresenzeGiustificativoEx> = (json?) => {
        return merge<PresenzeGiustificativoEx, Partial<PresenzeGiustificativoEx> | undefined>(
            {...PresenzeGiustificativo.factory(), giustificativo: null}
            , json);
    }
}

export interface GiuFormValues extends FieldValues {
    giustificativiHHGiornata: PresenzeGiustificativoEx[],
    giustificativiQIGiornata: PresenzeGiustificativoEx[]
}

// Metodo per inizializzare i valori del form sulla base dei giustificativi della giornata indicata in <day>
export const setupDefaultValues = (day: PresenzeGiornataPlusRecord, giustificativi: GiustificativoRecord[]): GiuFormValues => {
    const giustificativiHHGiornata: PresenzeGiustificativoEx[] = [];
    const giustificativiQIGiornata: PresenzeGiustificativoEx[] = [];
    if (day && day.causaliHH && day.causaliHH.length) {
        day.causaliHH.forEach(giustificativoGiornata => {
            if (giustificativoGiornata && giustificativoGiornata.codGiu) {
                const newGiust = PresenzeGiustificativoEx.factory(giustificativoGiornata);
                newGiust.giustificativo = giustificativi.find(v => v.codGiu!.toUpperCase() === giustificativoGiornata.codGiu.toUpperCase()) || null;
                giustificativiHHGiornata.push(newGiust);
            }
        });
    }
    if (!giustificativiHHGiornata.length)
        giustificativiHHGiornata.push(PresenzeGiustificativoEx.factory());

    if (day && day.causaliQI && day.causaliQI.length) {
        day.causaliQI.forEach(giustificativoGiornata => {
            if (giustificativoGiornata && giustificativoGiornata.codGiu) {
                const newGiust = PresenzeGiustificativoEx.factory(giustificativoGiornata);
                newGiust.giustificativo = giustificativi.find(v => v.codGiu!.toUpperCase() === giustificativoGiornata.codGiu.toUpperCase()) || null;
                giustificativiQIGiornata.push(newGiust);
            }
        });
    }
    if (!giustificativiQIGiornata.length)
        giustificativiQIGiornata.push(PresenzeGiustificativoEx.factory()); // N.B. Il factory imposta ORARIO come <tipoGiu>, è irrilevante perchè la tipologia corretta verrà impostato in inserimento del giustificativo!

    return {giustificativiHHGiornata, giustificativiQIGiornata};
}
